import HeaderOrange from "../../../../components/common/HeaderOrange/HeaderOrange";
import { useState } from "react";
import Tabs from "../../../../components/common/Tabs/Tabs";
import All from "./All/All";
import Invoices from "./Invoices/Invoices";
import ShippingLabels from "./ShippingLabels/ShippingLabels";
import RelatedMaterials from "./RelatedMaterials/RelatedMaterials";

const DocumentTemplate = () => {
  const tabs = ["All", "Invoices", "Shipping Labels", "Related Materials"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const listData = [
    { label: "Invoices:", value: "System-generated based on transaction data." },
    { label: "Shipping Labels:", value: "Generated using Maelano-specific templates." },
    { label: "Related Materials:", value: "Other necessary documents generated as needed." },
  ];

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", padding: "20px 30px" }}>
      <div className="fw-semibold fs-4 mb-3">Document Template</div>

      <HeaderOrange>
        The Document Template page is designed to manage and view
        automatically generated documents like invoices, shipping labels, and
        related materials. Maelano's system ensures consistency and compliance
        with platform standards by generating these documents automatically.
      </HeaderOrange>

      <div className="p-2 bg-white mb-3">
        <div className="border border-subtle-secondary p-3">
          <div>
            <b>Purpose:</b> This section showcases the templates used by the
            system to automatically generate essential documents.
          </div>
          <div>
            <b>Document Types:</b>
          </div>
          <div>
            <ul className="mb-0">
              {listData.map((item, index) => (
                <li key={index}>
                  <span className="fw-semibold">{item.label}</span>&nbsp;
                  <span>{item.value}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <Tabs activeTab={activeTab} tabs={tabs} setActiveTab={setActiveTab} />

      {activeTab === "All" && <All />}
      {activeTab === "Invoices" && <Invoices />}
      {activeTab === "Shipping Labels" && <ShippingLabels />}
      {activeTab === "Related Materials" && <RelatedMaterials />}
    </div>
  );
};

export default DocumentTemplate;